/**
 * Created by tomers on 12/27/2016.
 */
define(function (require) {
    'use strict';

    var LE = require("app");
    var Page = require("ui.components/page/Page");
    var CONST = require("const");
    var ErrorCodes = require("codeTables/errorCodes.json");

    var Dialog = require("ui/dialog/Dialog");
    var AuditTrailReviewChangesDialogView = require("manager-views/audit-trail/AuditTrailReviewChangesDialogView");
    var AuditTrailLayout = require("manager-views/audit-trail/AuditTrailLayout");
    var AuditTrailGridView = require("manager-views/audit-trail/AuditTrailGridView");
    var AuditTrailFilters = require("manager-filters/AuditTrailFilters");

    var AuditTrailController = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        AuditTrailController = Marionette.Controller.extend({
            pageView: null,
            insideView: null,
            needToFetchSiteSettings: false,
            initialize: function(options) {
                this._initialize(options);
            },
            getMainView: function() {
                return this._getMainView();
            },
            fetchData: function() {
                this._fetchData();
            },

            _initialize: function(options) {
                options = options || {};
                LEManager.logger.info("initializing", "AuditTrailController:initialize", options);
                this.channel = LEManager.media.channel("auditTrail");
                this.siteSettingsCollection = LEManager.getModuleDataManager().getSiteSettingsMyDetailsCollection();
                this.auditTrailCollection = LEManager.getModuleDataManager().getAuditTrailCollection();
                this._setDefaultAuditTrailFilters();
                this._bindEvents();
            },

            _bindEvents: function() {
                LEManager.logger.debug("init events of the page", "AuditTrailController:_bindEvents");
                this.listenTo(LE.vent, "siteSettings:timeZoneSwitched", this._onTimeZoneChanged); // when timezone is changed we need to re-fetch it from the site-settings
                this.listenTo(LE.vent, "siteSettings:timeZoneSwitched:userLevel", this._onTimeZoneChanged); // when timezone is changed we need to re-fetch it from the site-settings
                this.listenTo(this.channel, "auditTrail:export", this._onExportClick);
                this.listenTo(this.channel, "auditTrail:paging:change", this._onPagingChange);
                this.listenTo(this.channel, "auditTrail:page:close", this._onCloseClick);
                this.listenTo(this.channel, 'auditTrail:reviewChangesDialog:show', this._showReviewChangesDialog);
                this.listenTo(this.channel, "auditTrail:reviewChangesDialog:cancel", this._onDialogCancel);
            },

            _setDefaultAuditTrailFilters: function() {
                var language = LE.siteSettings.languageSettings.getAccountLocale();
                var timezone = LE.siteSettings.timeZoneSettings.getCurrentTimeZone();

                this.auditTrailCollection.setFilterValue(this.auditTrailCollection.FILTERS_ENUM.LANGUAGE, language, {fetchOnChange: false});
                this.auditTrailCollection.setFilterValue(this.auditTrailCollection.FILTERS_ENUM.TIMEZONE, timezone, {fetchOnChange: false});
            },

            _onTimeZoneChanged: function() {
                this.needToFetchSiteSettings = true;
            },

            _getMainView: function() {
                this._initPageView();
                return this.pageView;
            },

            _initPageView: function() {
                LEManager.logger.debug("init page view and listen to its close", "AuditTrailController:_initPageView");
                this.pageView = new Page({
                    moduleName: LEManager.moduleName,
                    context: LE.context,
                    header:{
                        title: LE.translator.translate("LEManager.auditTrail.title"),
                        description: LE.translator.translate("LEManager.auditTrail.description"),
                        knowledgePack: {text: LE.translator.translate("LEFramework.global.captions.learnMore"), eventId: "audit-trail"}
                    },
                    hasActionStrip: true
                });
                this.listenTo(this.pageView, "close", _.bind(this._onPageClose, this, this.pageView));
            },

            _onPageClose: function(closedPageView) {
                LEManager.logger.debug("Page component in audit is closed. re-init it.", "AuditTrailController:_onPageClose");
                if (closedPageView) {
                    this.stopListening(closedPageView);
                }

                if (this.pageView && closedPageView && closedPageView.cid === this.pageView.cid) {
                    this.pageView = null;
                    this.insideView = null;
                }
            },

            _fetchData: function() {
                if (this.needToFetchSiteSettings) {
                    this.needToFetchSiteSettings = false;
                    this._fetchSiteSettings();
                }
                else {
                    this._fetchAuditTrail();
                }
            },

            _fetchSiteSettings: function() {
                LEManager.getModuleDataManager().getDependencies({
                    dependencies: [ LEManager.getModuleDataManager().getEntities().SITE_SETTINGS_MY_DETAILS ],
                    success: _.bind(this._onFetchSiteSettingsSuccess, this)
                });
            },

            _onFetchSiteSettingsSuccess: function() {
                var language = this.siteSettingsCollection.get(this.siteSettingsCollection.SETTINGS_ENUM.SETTING_ID.LOCALE).getValue();
                var timezone = this.siteSettingsCollection.get(this.siteSettingsCollection.SETTINGS_ENUM.SETTING_ID.TIME_ZONE).getValue();

                this.auditTrailCollection.setFilterValue(this.auditTrailCollection.FILTERS_ENUM.LANGUAGE, language, {fetchOnChange: false});
                this.auditTrailCollection.setFilterValue(this.auditTrailCollection.FILTERS_ENUM.TIMEZONE, timezone, {fetchOnChange: false});

                this._fetchAuditTrail();
            },

            _fetchAuditTrail: function() {
                LEManager.getModuleDataManager().getDependencies({
                    dependencies: [ LEManager.getModuleDataManager().getEntities().AUDIT_TRAIL ],
                    success: _.bind(this._onFetchAuditTrailSuccess, this)
                });
            },

            _onFetchAuditTrailSuccess: function() {
                this.auditTrailGridView = new AuditTrailGridView({
                    collection: this.auditTrailCollection,
                    filters: AuditTrailFilters,
                    channel: this.channel
                });

                this.auditTrailLayoutView = new AuditTrailLayout({
                    collection: this.auditTrailCollection
                });

                this.listenToOnce(this.auditTrailLayoutView, "render", _.bind(function(){
                    this.auditTrailLayoutView.tableRegion.show(this.auditTrailGridView);
                },this));
                this.pageView.setInsideView(this.auditTrailLayoutView);
            },

            _onPagingChange: function(currentPageNumber) {
                LEManager.logger.debug("_onPagingChange " + currentPageNumber , "AuditTrailController:_onPagingChange");
                this.auditTrailCollection.setPage(currentPageNumber);
            },

            _onExportClick: function() {
                if(this.exportNotifierError) {
                    this.exportNotifierError.close();
                }

                this.exportNotifierStart = LEManager.notifier.showInfo(LE.translator.translate("LEManager.auditTrail.export.text"));

                this.auditTrailCollection.exportAuditTrail({
                    success: _.bind(this._onExportSuccess, this),
                    error: _.bind(this._onExportError, this),
                    timeout: 180000
                });
            },

            _onExportSuccess: function(model, response, options) {
                LEManager.logger.debug("fetch audit trail export - success", "AuditTrailController:_onExportSuccess");
            },

            _onExportError: function(model, response, options) {
                LEManager.logger.error("fetch audit trail export - error", "AuditTrailController:_onExportError");

                this.exportNotifierStart.close();

                var notifierContent, actionText, actionCallback, removeAditionalButton;
                if (response && response.responseError && response.responseError.internalCode === ErrorCodes.maxExportRecords) {
                    notifierContent = LE.translator.translate("LEManager.auditTrail.export.error.maxRecords.text");
                    actionText = LE.translator.translate("LEFramework.global.captions.ok");
                    actionCallback = function() {};
                    removeAditionalButton = true;
                }
                else {
                    notifierContent = LE.translator.translate("LEFramework.global.please.try.again");
                    actionText = LE.translator.translate("LEFramework.global.captions.try.again");
                    actionCallback = _.bind(this._onExportClick, this);
                    removeAditionalButton = false;
                }


                this.exportNotifierError = LEManager.notifier.showError({
                    title: LE.translator.translate("LEFramework.global.export.failed"),
                    content: notifierContent,
                    type: CONST.SYSTEM_NOTIFICATIONS.ERROR,
                    objectAction: {
                        text: actionText,
                        callback: actionCallback
                    },
                    removeAditionalButton: removeAditionalButton
                });
            },

            _onCloseClick: function() {
                LEManager.router.navigateBack();
            },

            _showReviewChangesDialog: function(model) {
                LEManager.logger.info("show dialog", "AuditTrailController:_showReviewChangesDialog");

                this.auditTrailReviewChangesDialogView = new AuditTrailReviewChangesDialogView({ model: model });
                this.auditTrailReviewChangesDialog = new Dialog({
                    permutation: Dialog.PERMUTATION.D,
                    innerView: this.auditTrailReviewChangesDialogView,
                    moduleName: LEManager.moduleName,
                    context: LE.context
                });
                this.auditTrailLayoutView.dialogRegion.show(this.auditTrailReviewChangesDialog);
                this.listenTo(this.auditTrailReviewChangesDialogView, "auditTrailReviewChangesDialogView:closeDialog", this._closeReviewChangesDialog);
            },

            _closeReviewChangesDialog: function () {
                this.stopListening(this.auditTrailReviewChangesDialogView);
                this.auditTrailLayoutView.dialogRegion.close();
                this.auditTrailReviewChangesDialog.close();
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    return  AuditTrailController;
});
